import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomTable from "../../../../components/table/table";
import ResourseCard from "../../../../components/page/tiles/resourcecard";
import {
  download_resource_person_file,
  user_res_per_details,
  user_resource_detail,
} from "../../user.api";

import "../style.css";
import BreadCrumbsComp from "../../../../components/navigator/breadcrumbs";
import moment from "moment";
import CustomIcons from "../../../../components/icons/kIcons.component";
let count = 100;
export default function ResourcePersonalDetails(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const selectedParam = useParams();
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const getDetails = (id) => {
    user_resource_detail(id).then((res) => {
      let tdata = res.data[0];

      setData(tdata);
      setIsActive(false);
    });
  };
  useEffect(() => {
    getDetails(selectedParam.id);
  }, []);
  const handleDownloadResume = (data) => {
    let path = `${result}${data}`;
    window.open(path, "_blank");
  };

  // const handleDownloadDocument = async (id) => {
  //   if (!id) {
  //     console.error("User ID is missing for download");
  //     return;
  //   }

  //   try {
  //     const response = await download_resource_person_file(id);

  //     if (response) {
  //       const fileUrl = response.data.file_url;
  //       console.log("Download URL:", fileUrl);

  //       // Open the file in a new tab
  //       window.open(fileUrl, "_blank");
  //     } else {
  //       console.error("File URL not found in API response");
  //     }
  //   } catch (error) {
  //     console.error("Error downloading file:", error);
  //   }
  // };

  const handleDownloadDocument = async (id) => {
    if (!id) {
      console.error("User ID is missing for download");
      return;
    }

    try {
      const response = await download_resource_person_file(id);

      // Extract the file URL from the response
      const fileUrl = response?.url;

      if (!fileUrl) {
        console.error("Invalid response: No URL found in API response.");
        return;
      }

      // Open the file in a new tab
      const newTab = window.open(fileUrl, "_blank");

      // Handle cases where the browser blocks pop-ups
      if (!newTab) {
        alert("Popup blocked! Please allow popups for this site.");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  const handleDownload = (dt) => {
    let path = `${result}${dt.file_upload_certificate}`;
    window.open(path, "_blank");
  };
  const handleExpDownload = (dt) => {
    let path = `${result}${dt}`;
    window.open(path, "_blank");
  };
  const handleDownloadExpCert = (data) => {
    let path = `${result}${data}`;
    window.open(path, "_blank");
  };

  return (
    <div className="">
      <BreadCrumbsComp section="resoursePerssonalDetails" />
      <div className="container p-50">
        <div className="res-page-cont-details">
          <div className="row tender-head ">
            <h4> Resource Personnel Details </h4>
          </div>
          <div className="row ">
            <div className="col-xs-12 ">
              {/* <div className="profile-box "> */}
              <div className="res-bannerContainer d-flex ">
                {/* <div className="res-ban-image ">
                  <img
                        src="/resources/img/userdashbanner.png"
                        className="w-100 res-ban-img"
                        alt=""
                      />
                </div> */}
                <div className="">
                  <div className="res-ban-data">
                    <div>
                      <img
                        src={`${result}${data?.file_upload}`}
                        className="res-profile-img"
                        alt=""
                      />
                    </div>
                    <div className="profile-res-con">
                      <div className="res-person-name">
                        {data.title ? data.title + "." : "Mr."}{" "}
                        {data.first_name ?? ""} {data.last_name ?? ""}
                      </div>
                      <div className="qualification-container">
                        <div className="res-exp">Domain Types</div>
                        <div className="expertise-tags">
                          {(data?.domain_types || []).map((item, i) => (
                            <span key={i} className="expertise-tag">
                              {item.domain_name}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="data details-card">
                <div className="row res-person-name ">
                  <div className="col-3">Full Name</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {data.title ? data.title + "." : "Mr."}{" "}
                    {data.first_name ?? ""} {data.last_name ?? ""}
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">Date of Birth</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{data?.date_of_birth}</div>
                </div>
                <div className="row">
                  <div className="col-3">Gender</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {data?.gender == 1
                      ? "Male"
                      : data?.gender == 2
                        ? "Female"
                        : "Others"}
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">Address</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{data?.address}</div>
                </div>

                <div className="row">
                  <div className="col-3">Email</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{data?.email}</div>
                </div>
                <div className="row">
                  <div className="col-3">Phone Number</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{data?.phone_no}</div>
                </div>
                {data?.alternate_phone && (
                  <div className="row">
                    <div className="col-3">Alternate Phone</div>
                    <div className="col-1">:</div>
                    <div className="col-7">{data?.alternate_phone}</div>
                  </div>
                )}
                <div className="row">
                  <div className="col-3">Languages Known</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <div className="expertise-tags">
                      {(data?.languages || []).map((item, i) => (
                        <span key={i} className="expertise-tag">
                          {item?.language_name}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">Domain Types</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <div className="expertise-tags">
                      {(data?.domain_types || []).map((item, i) => (
                        <span key={i} className="expertise-tag">
                          {item.domain_name}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">Expert in</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <div className="expertise-tags">
                      {(data?.area_of_expertise || []).map((item, index) => (
                        <span key={index} className="expertise-tag">
                          {item.expertise_name}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">Resume</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <button
                      className="btn btn-approved btn-success mt-2"
                      onClick={() =>
                        handleDownloadResume(data?.resume)
                      }
                    >
                      Download Resume
                    </button>
                    {/* <div
                      className="text-primary"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => handleDownloadResume(data?.resume)}
                    >
                      Download Resume
                    </div> */}
                  </div>
                </div>
                {/* 
                <div className="row">
                  <div className="col-3">Educational Qualification</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {" "}
                    <div className="col-12  overflow-auto">
                      {" "}
                      <CustomTable
                        className="areatable"
                        {...props}
                        columns={[
                          {
                            title: " Examination passed",
                            field: "examination_passed",
                          },
                          {
                            title: "Board/University",
                            field: "board_of_university",
                          },
                          {
                            title: "Year of Passing",
                            field: "year_of_pass",
                          },
                          { title: "Mark/grade", field: "mark_grade" },
                          {
                            title: "Certificate",
                            field: "file_upload_certificate",
                            type: "download",
                          },
                        ]}
                        data={data?.education ?? []}
                        handleDownload={handleDownload}
                      />
                    </div>
                  </div>
                </div> */}
                {/* <div className="row">
                  <div className="col-3">Educational Qualification</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <div className="col-7">
                      {data &&
                        data?.education &&
                        data?.education?.length !== 0 && (
                          <>
                            {data?.education?.map((item, index) => (
                              <div className="white">
                                <div>
                                  <b>Examination passed</b>
                                  <p>{item.examination_passed}</p>
                                </div>
                                <div>
                                  <b>Board/University</b>
                                  <p>{`${item.board_of_university} Years`}</p>
                                </div>
                                <div>
                                  <b>Year of Passing</b>
                                  <p>{item.year_of_pass}</p>
                                </div>
                                <div>
                                  <b>Mark/grade</b>
                                  <p>{item.mark_grade}</p>
                                </div>
                                
                                <div>
                                  <b>Certificate</b>
                                  <p>
                                    <button
                                      className="btn btn-approved btn-success mt-2"
                                      onClick={() =>
                                        handleExpDownload(
                                          item.file_upload_certificate
                                        )
                                      }
                                    >
                                      Download
                                    </button>
                                  </p>
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                    </div>
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-3">Experience Details</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <div className="col-7">
                      {data &&
                        data?.experience &&
                        data?.experience.length !== 0 && (
                          <>
                            {data?.experience?.map((item, index) => (
                              <div className="white">
                                <div>
                                  <b>Organization with Address</b>
                                  <p>{item.organization_name}</p>
                                </div>
                                <div>
                                  <b>Experience</b>
                                  <p>{`${item.experience} Years`}</p>
                                </div>
                                <div>
                                  <b>Nature of Work</b>
                                  <p>{item.nature_of_work}</p>
                                </div>
                                <div>
                                  <b>Designation</b>
                                  <p>{item.designation}</p>
                                </div>
                                <div>
                                  <b>Reason for Leaving</b>
                                  <p>{item.reason_for_leaving}</p>
                                </div>
                                {/* <div>
                                  <b>Experience Letter/Experience Certificate</b>
                                  <p>
                                    <button
                                      className="btn btn-approved btn-success mt-2"
                                      onClick={() =>
                                        handleExpDownload(
                                          item.experience_certificate
                                        )
                                      }
                                    >
                                      Download
                                    </button>
                                  </p>
                                </div> */}
                              </div>
                            ))}
                          </>
                        )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    Willingness to travel within India / abroad
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {data?.travell_interest == 1 ? "Yes" : "No"}
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    Are you currently attached / committed to any Organization ?
                    Give details
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">{data?.desc_of_current_work}</div>
                </div>
                {/* <div className="row">
                  <div className="col-3">Created At</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {data?.created_at
                      ? moment(data?.created_at).format("DD-MM-YYYY")
                      : ""}
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
